import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { IEnvironment } from 'app/projects/core/src/lib/interfaces/environment.interface';
import { MAXBRAIN_ENVIRONMENT } from 'app/projects/core/src/lib/services/environment.token';
import { IEntityApiService } from 'app/projects/entity/src/lib/interfaces/entity.service.interface';
import { EntityService } from 'app/projects/entity/src/lib/services/entity.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ITagQuery } from '../interfaces/tag.query.interface';
import { TagCommand } from '../models/tag.command.model';
import { MaxBrainTag } from '../models/tag.model';

@Injectable()
export class TagApiService extends EntityService<ITagQuery, TagCommand> implements IEntityApiService<MaxBrainTag> {
    constructor(http: HttpClient, @Inject(MAXBRAIN_ENVIRONMENT) environment: IEnvironment) {
        super(http, environment.apiUrl, 'tags');
    }

    getAll(): Observable<MaxBrainTag[]> {
        return this._getAll().pipe(map((queries) => queries.map((query) => new MaxBrainTag(query))));
    }

    create(entity: MaxBrainTag): Observable<MaxBrainTag> {
        const data = new TagCommand(entity);

        return this._create(data).pipe(map((query) => new MaxBrainTag(query)));
    }

    read(id: string): Observable<MaxBrainTag> {
        return this._read(id).pipe(map((query) => new MaxBrainTag(query)));
    }

    update(entity: MaxBrainTag): Observable<MaxBrainTag> {
        const data = new TagCommand(entity);

        return this._update(entity.id, data).pipe(map((query) => new MaxBrainTag(query)));
    }

    delete(id: string): Observable<any> {
        return this._delete(id);
    }
}
